module.exports = __webpack_public_path__ + "static/media/planner.0d8b9c6e.png";